import { LineChart, PieChart } from 'echarts/charts'
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([LineChart, PieChart, TitleComponent, GridComponent, LegendComponent, TooltipComponent, CanvasRenderer])

export * from './AnalyzeSettings'
export * from './AnalyzeTraffic'
